import { client } from '@/proxy/client'
import { gql } from 'graphql-request'
import { useQuery } from '@/proxy/react-query'

export const SELLER_MUST_SIGN_CONTRACT = gql`
  query sellerMustSignContract {
    seller {
      permissions {
        mustSignContractState
      }
    }
  }
`

export const SELLER_MUST_SIGN_CONTRACT_KEY = 'useSellerMustSignContract'

export const useSellerMustSignContract = options =>
  useQuery({
    queryKey: [SELLER_MUST_SIGN_CONTRACT_KEY],
    queryFn: variables => client.request(SELLER_MUST_SIGN_CONTRACT, variables),
    ...options,
  })
